import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getPaymentList = createAsyncThunk(
    "payment/list",
    async ({ pageCount, limit, search }) => {
        const response = await Client(
            API_METHOD.GET,
            url.payments +
            `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${!search ? "" : search
            }`
        );
        return response.data;
    }
);

// export const getPPurchaseCount = async () => {
//     const response = await Client(API_METHOD.GET, url.banners)
//     return response.data?.data?.item?.total_count;
// }

// export const getPurchase = createAsyncThunk("banner/one", async (id) => {
//     const response = await Client(API_METHOD.GET, url.banners + `/${id}`);
//     return response.data;
// });

